import { render, staticRenderFns } from "./EnemyPrincipal.vue?vue&type=template&id=c88922b8&scoped=true"
import script from "./EnemyPrincipal.vue?vue&type=script&lang=js"
export * from "./EnemyPrincipal.vue?vue&type=script&lang=js"
import style0 from "./EnemyPrincipal.vue?vue&type=style&index=0&id=c88922b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88922b8",
  null
  
)

export default component.exports